export default __webpack_public_path__ + "static/media/zcrfm.67140713.png";